import { AdminSubRole } from './role';
import { UserClaimsData } from './userData';

export interface AdminClaimsData extends UserClaimsData {
  subrole: AdminSubRole;
}

export enum Department {
  CompSciEng = 'cse',
  Humanities = 'hss',
  SciMath = 'sm',
  Lifestyle = 'ssl',
  Arts = 'a',
  WorldLang = 'wl',
}

export interface DepartmentChairClaimsData extends AdminClaimsData {
  department: Department;
}
